import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'baremetal' },
  path: 'baremetal/:server_id',
  component: () => import('@/views/dashboard/baremetal/server/root.vue'),
  redirect: () => ({ name: 'server/overview' }),
  children: [
    {
      path: 'overview',
      name: 'server/overview',
      component: () => import('@/views/dashboard/baremetal/server/overview.vue'),
    },
    {
      path: 'networks',
      name: 'server/networks',
      component: () => import('@/views/dashboard/baremetal/server/networks.vue'),
    },
    {
      path: 'recovery',
      name: 'server/recovery',
      component: () => import('@/views/dashboard/baremetal/server/recovery.vue'),
    },
    {
      path: 'history',
      name: 'server/history',
      component: () => import('@/views/dashboard/baremetal/server/history.vue'),
    },
  ],
} satisfies RouteRecordRaw;
